import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import Header from "./components/Header";
import Footer from "./components/Footer";
import HomePage from "./pages/HomePage";
import WorkflowDetailsPage from "./pages/WorkflowDetailsPage";
import "./App.css";
import WorkflowsPage from "./pages/WorkflowsPage";
import WorkflowPage from "./pages/WorkflowPage";
import VisualizePage from "./pages/VisualizePage";
import CommunityPage from "./pages/CommunityPage";
import DiscussionPage from "./pages/DiscussionPage";
import NewDiscussionPage from "./pages/NewDiscussionPage";
import SettingsPage from "./pages/SettingsPage";
import ProfilePage from "./pages/ProfilePage";
import AccountPage from "./pages/AccountPage";
import TokensPage from "./pages/TokensPage";
import AdminTasksPage from "./pages/AdminTasksPage";
import { createRunnerApi } from "./api/runner_api";
import UserProfilePage from "./pages/UserProfilePage";
import UserTasksPage from "./pages/UserTasksPage";
import SearchPage from "./pages/SearchPage";
import EditWorkflowPage from "./pages/EditWorkflowPage";
import TermsPrivacyPage from "./pages/TermsPrivacyPage";
import StudioPage from "./pages/StudioPage";
import ProtectedAdminRoute from "./components/ProtectedAdminRoute";

const App = () => {
  const [search, setSearch] = useState("");

  return (
    <Router>
      <div className="app">
        <Header onSearch={setSearch} />
        <div className="main-content">
          <Routes>
            <Route path="/" element={<HomePage search={search} />} />
            <Route path="/workflows" element={<WorkflowsPage />} />
            <Route path="/workflow/:id" element={<WorkflowPage />}>
              <Route index element={<WorkflowDetailsPage />} />
              <Route path="example" element={<VisualizePage />} />
              <Route path="community" element={<CommunityPage />}></Route>
              <Route
                path="community/:discussionId"
                element={<DiscussionPage />}
              />
              <Route path="community/new" element={<NewDiscussionPage />} />
            </Route>
            <Route path="/workflow/:id/edit" element={<EditWorkflowPage />} />
            <Route path="/settings" element={<SettingsPage />}>
              <Route index element={<Navigate to="account" />} />
              {/* <Route path="profile" element={<ProfilePage />} /> */}
              <Route path="account" element={<AccountPage />} />
              <Route path="tokens" element={<TokensPage />} />
              <Route path="tasks" element={<UserTasksPage />} />
            </Route>
            <Route path="/u/:id" element={<UserProfilePage />} />
            <Route
              path="/tasks"
              element={
                <ProtectedAdminRoute>
                  <AdminTasksPage />
                </ProtectedAdminRoute>
              }
            />
            {process.env.REACT_APP_INCLUDE_SA_TASKS === "true" && (
              <Route
                path="/admin/sa-tasks"
                element={
                  <ProtectedAdminRoute>
                    <AdminTasksPage
                      runnerApi={createRunnerApi(
                        process.env.REACT_APP_SA_RUNNER_URL ||
                          process.env.REACT_APP_RUNNER_URL,
                      )}
                    />
                  </ProtectedAdminRoute>
                }
              />
            )}
            <Route path="/search" element={<SearchPage />} />
            <Route path="/terms-privacy" element={<TermsPrivacyPage />} />
            {process.env.REACT_APP_INCLUDE_STUDIO === "true" && (
              <Route path="/studio" element={<StudioPage />} />
            )}
          </Routes>
        </div>
        <Footer />
      </div>
    </Router>
  );
};

export default App;
